/**
 * AdBlock и другие блокеры не блокируют базовый скрипт DFP
 * url: https://www.googletagservices.com/tag/js/gpt.js
 * Блокируются внутренние скрипты, которые подгружаются базовым скриптом.
 *
 * У DFP нет хуков или колбэков на такой случай, так что воспользуемся
 * slotRequested и slotResponseReceived событиями, чтобы определить
 * ушёл ли запрос в DFP сервис и смог ли запрос вернуться.
 *
 * Если не отрабатывает событие slotResponseReceived, то это является
 * индикатором того, что запрос был заблокирован.
 *
 * На запрос даётся таймаут в requestTimeout миллисекунд, если запрос
 * не завершился за это время (не вызвался обработчик slotResponseReceived события)
 * то мы считаем, что рекламные сервисы DFP заблокированы
 *
 * @param adBlockCallback
 */

let isReceived = false;
export const adsRequestTimeout = 3000;
const detectAdBlocker = (adBlockCallback, customTimeout) => {
  if (typeof googletag !== 'undefined' && googletag.apiReady) {
    googletag.pubads().addEventListener('slotResponseReceived', event => {
      isReceived = true;
    });
    googletag.pubads().addEventListener('slotRequested', event => {
      setTimeout(function() {
        if (adBlockCallback && !isReceived) {
          adBlockCallback();
        }
      }, customTimeout || adsRequestTimeout);
    });
  }
};

export default detectAdBlocker;
